
import projectOne from '../../assets/imgs/ProjectOne.png'
import projectTwo from '../../assets/imgs/ProjectTwo.png'
import projectThree from '../../assets/imgs/projectThree.png'
import projectFour from '../../assets/imgs/projectFour.png'
import projectFive from '../../assets/imgs/projectFive.png'
import projectSix from '../../assets/imgs/projectSix.png'

const ProjectData = [
    {
        img: projectOne,
        hadding: "Pizzeria",
        webLink: "https://pizzeria-theta.vercel.app/",
        paragraph: "This is an online platform for restaurant, featuring menu for ordering food."
    },
    {
        img: projectTwo,
        hadding: "MUR Portfolio",
        webLink: "https://mur-porfolio.surge.sh/",
        paragraph: 'A developer portfolio showcasing projects, skills, and contact details.'
    },
    {
        img: projectThree,
        hadding: "LexiMind",
        webLink: "https://leximind.vercel.app/",
        paragraph: 'Leximind: interactive web app for vocab building & word exploration.'
    },
    {
        img: projectFour,
        hadding: "Noor AlIslam Academy",
        webLink: "https://noor-alislam-edu.web.app/",
        paragraph: 'Noor Al-Islam is a web app that provides online Quran learning with expert teachers.'
    },
    {
        img: projectFive,
        hadding: "Personal Portfolio",
        webLink: "https://mu-portfolio.web.app/",
        paragraph: 'My personal portfolio web App.This project also build using React.js & Goggle Firebase.'
    },
    {
        img: projectSix,
        hadding: "Bloging Website",
        webLink: "https://blog-by-umar.web.app/",
        paragraph: 'This project Develop using Vite+React, CSS Framwork Tailwinds & backend Goggle Firebase.'
    },
]

export default ProjectData;